import React from 'react';
import './addresscard.css';

const AddressCard = ({ address, isSelected, onSelect, onEdit, onDelete }) => {
  return (
    <div
      className={`address-card ${isSelected ? 'selected' : ''}`}
      onClick={() => onSelect(address)}
    >
      <div className="address-details">
        <h3>{address.fullName}</h3>
        <p><strong>Contact:</strong> {address.contactNumber}</p>
        <p><strong>Email:</strong> {address.email}</p>
        <p><strong>Address:</strong> {address.address}</p>
        <p><strong>Pincode:</strong> {address.pincode}</p>
        <p><strong>State:</strong> {address.state}</p>
        {address.landmark && <p><strong>Landmark:</strong> {address.landmark}</p>}
      </div>

      <div className="address-actions">
        <button onClick={(e) => { e.stopPropagation(); onEdit(address); }}>Edit</button>
        <button onClick={(e) => { e.stopPropagation(); onDelete(address._id); }}>Delete</button>
      </div>
    </div>
  );
};

export default AddressCard;
